import { render, staticRenderFns } from "./RightV1.vue?vue&type=template&id=304e0d50&scoped=true"
import script from "./RightV1.vue?vue&type=script&lang=js"
export * from "./RightV1.vue?vue&type=script&lang=js"
import style0 from "./RightV1.vue?vue&type=style&index=0&id=304e0d50&prod&lang=css&scoped=true"
import style1 from "./RightV1.vue?vue&type=style&index=1&id=304e0d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e0d50",
  null
  
)

export default component.exports